<template>
    <div>
        <st-divider class="auth-title" :between="3.4">
            <div>휴대폰으로 수신된</div>
            <div>인증번호를 입력해주세요.</div>
        </st-divider>
        <st-divider :between="2">
            <st-input v-model="authcode" :width="37.5" placeholder="인증번호를 입력해주세요." @enter="submitHandler" />
            <div class="error-text">
                <span v-show="error">
                    <awesome-icon name="exclamation-circle" />인증번호를 다시 한번 확인 해주세요.
                </span>
            </div>
        </st-divider>
        <st-divider :between="4">
            <!-- || !phone -->
            <st-button :width="27.5" color="primary" :disabled="!authcode" @click="submitHandler">
                인증하기
            </st-button>
        </st-divider>
        <div class="auth-waring re-send-code">
            혹시 인증번호를 못받으셨나요?
            <span v-if="timer !== null">({{ format_time }})</span>
            <span class="abled-span" v-else @click="resendCode">인증번호 재발송</span>
        </div>
    </div>
</template>
<script>
import { dataEncoded } from "../../../utils/lib";

const props = {
    phone: String
};

export default {
    name: "AuthCode",
    data: () => ({
        authcode: null,
        error: false,
        timer: null,
        time: 60000
    }),
    props: { ...props },
    computed: {
        format_time() {
            const date = new Date(this.time);
            const m = date.getMinutes();
            const s = date.getSeconds();

            const $m = m < 10 ? "0" + m : m;
            const $s = s < 10 ? "0" + s : s;

            return `${$m}:${$s}`;
        }
    },
    methods: {
        async submitHandler() {
            try {
                const data = dataEncoded({ phoneNumber: this.phone, code: this.authcode });
                const response = await this.$api.user.authCode(data);
                const { userId, token } = response.data;

                this.$emit("auth-code", { userId, token });
            } catch (e) {
                this.error = true;
                // this.$alert("error", e.message);
            }
        },

        async resendCode() {
            const data = dataEncoded({ phoneNumber: this.phone });
            try {
                const response = await this.$api.user.makeAuth(data);

                if (response.data.resultCode === 10001) {
                    this.run();
                    this.$alert("info", "인증번호를 재발송 하였습니다.");
                }
            } catch (e) {
                this.$alert("error", e.message);
            }
        },

        timeFlow() {
            this.time -= 1000;

            if (this.time === 0) {
                clearInterval(this.timer);
                this.timer = null;
                this.time = 3000;
            }
        },

        run() {
            this.timer = setInterval(() => {
                this.timeFlow();
            }, 1000);
        }
    },
    mounted() {
        this.run();
    }
};
</script>
